import { Typography } from "@material-ui/core";
import React, { useCallback, useContext, useState } from "react";
import { useFormContext } from "react-hook-form";
import airportApi from "../../../api/airport.api";
import { QuoteContextStore } from "../../../context/QuoteContext/QuoteContext";
import { debounce } from "../../../services/utils";
import { BetterControlledAutocomplete, ControlledAutocomplete } from "../../Core/Form/ControlledFields";

const AirportCityAutocomplete = ({...props}) => {
    const [cities, setCities] = useState([]);
    const { watch, setValue, getValues, reset } = useFormContext();
    const { loadAirport ,locked_quote} = useContext(QuoteContextStore);
    const state = watch("state");
    const name = watch("name");
    const notFound = watch("airport_not_found");

    async function filter(state, city, name) {
        if(!city) {
            const { data } = await airportApi.getCities(state , city, name);
            setCities(data);
            return;
        }
        if(city.length < 1) {
            const { data } = await airportApi.getCities(state , city, name);
            setCities(data);
            return;
        }
        const { data } = await airportApi.getCities(state , city, name);
        setCities(data);
    }
    
    const debounceHandler = useCallback(debounce(filter, 500), []);

    const handleFiltering = (e, value) => {
        if(!e) return;
        debounceHandler(state === 'default' ? "" : state, value, name);
    }

    const handleAirportPick = async (e, value) => {
        if(!value) {
            reset({...getValues(), name: "", city: "", runway_length: "", code: "",
            runway_length: "",
            runway_elevation: "",
            runway_surface: "default",
            airport_not_found: false});
            return;
        }
        if(!state || !name) {
            reset({...getValues(), 
            city: value, 
            runway_length: "", code: "",
            runway_length: "",
            runway_elevation: "",
            runway_surface: "default",
            airport_not_found: false});
            return;
        };
        const { data: airport } = await airportApi.getAirport(state , value, name);
        await loadAirport({...airport, airport_not_found: false});
    }

    const handleOnFocus = async (event) => {
        const { data } = await airportApi.getCities(state , "", name);
        setCities(data)
    }

    return !notFound ? <><Typography variant="h4" className="gray">Airport city</Typography><BetterControlledAutocomplete name="city" onFocus={handleOnFocus} className="margin-top-8" onChange={handleAirportPick} onInputChange={handleFiltering} placeholder="City" options={cities} disabled={locked_quote}/></> : <></>
}

export default AirportCityAutocomplete;